/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterArray extends models.ParameterBaseWithSchema {
    constructor() {
        super();
        this.setDiscriminator("ParameterArray");
    }

    getFixupPrototypeFunction() { return ParameterArray.fixupPrototype; }

    static newInstance(model: Partial<ParameterArray>): ParameterArray {
        let obj = Object.assign(new ParameterArray(), model);
        ParameterArray.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterArray>): ParameterArray {
        if (!model) return null;
        return ParameterArray.newInstance(<ParameterArray> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterArray) {
        if (!obj) return;

        models.ParameterArray.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterArray): boolean {
        if (models.ParameterBaseWithSchema.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterArray.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
